import apiClient from "../../utils/apiClient";
import apiService from "../apiService/apiService";

const getPlaylists = (page, searchTerm) => {
    const params = {
        'page': page,
        's': searchTerm,
    };

    const queryString = apiService.getRequestParams(params);
    const url = `/playlists${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const getSinglePlaylistData = (id) => {
    const url = `playlists/${id}`;
    return apiClient.get(url);
};

const addMasterClassToPlaylist = (playlistId, masterClassId) => {
    const url = `/playlists/${playlistId}/master-classes`;

    return apiClient.post(url, {
        master_class_id: masterClassId
    });
};

const removeMasterclassFromPlaylist = (playlistId, masterClassId) => {
    const url = `/playlists/${playlistId}/master-classes/${masterClassId}`;

    return apiClient.delete(url);
};

const getPlaylistMasterclasses = (playlistId, page, searchTerm) => {
    const params = {
        'page': page,
        's': searchTerm,
    };

    const queryString = apiService.getRequestParams(params);
    const url = `/playlists/${playlistId}/master-classes${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
};

const createPlaylist = (name) => {
    const url = `/playlists`;

    return apiClient.post(url, {
        name: name
    });
};

const deletePlaylist = (playlistId) => {
    const url = `/playlists/${playlistId}`;
    return apiClient.delete(url);
};

const updatePlaylist = (data, playlistId) => {
    const url = `/playlists/${playlistId}`;
    return apiClient.put(url, data);
};

export const playlistService = {
    getPlaylists,
    addMasterClassToPlaylist,
    removeMasterclassFromPlaylist,
    getSinglePlaylistData,
    getPlaylistMasterclasses,
    createPlaylist,
    deletePlaylist,
    updatePlaylist
};